export default __webpack_public_path__ + "static/media/player-frame.458de74f.png";